module.exports = __webpack_public_path__ + "img/logo_sas_landscape_darken.719d2e34.svg";